import { render, staticRenderFns } from "./TrainingAsignment.vue?vue&type=template&id=609ba6cc"
import script from "./TrainingAsignment.vue?vue&type=script&lang=ts"
export * from "./TrainingAsignment.vue?vue&type=script&lang=ts"
import style0 from "./TrainingAsignment.vue?vue&type=style&index=0&id=609ba6cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports